// src/pages/Users/Lexique/hooks/useLexiqueSpeech.js

import { useEffect, useMemo, useRef, useState } from "react";

import { hasJapaneseCharacters } from "../utils/lexiqueUtils";

export default function useLexiqueSpeech(japaneseText) {
  const [toKanaFn, setToKanaFn] = useState(null);
  const triedImport = useRef(false);

  useEffect(() => {
    if (triedImport.current) return;

    triedImport.current = true;

    async function loadWanakana() {
      try {
        const mod = await import("wanakana");

        if (mod?.toKana) {
          setToKanaFn(() => mod.toKana);
        }
      } catch {
        // Wanakana est optionnel.
      }
    }

    loadWanakana();
  }, []);

  return useMemo(() => {
    const raw = String(japaneseText || "").trim();

    if (!raw) return "";
    if (hasJapaneseCharacters(raw)) return raw;

    const cleaned = raw.replace(/[-_]+/g, " ").replace(/\s+/g, " ").trim();

    return toKanaFn ? toKanaFn(cleaned) : cleaned;
  }, [japaneseText, toKanaFn]);
}